import React from 'react';

import { connect } from 'react-redux';
import config from '../../config';
import { navigateTop } from '../routing/router-utils'; 
import ButtonWithPrice from '../styleguide/ButtonWithPrice';
import DisabledButtonWithReason from '../styleguide/DisabledButtonWithReason';

import PropTypes from 'prop-types';

/* styles shared across cart components */
import styles from '../checkout/Cart.module.css';

/**
 * Display Checkout button with price for pickup orders
 */
const CheckOutPickupButton = ({ 
  dispensaryId,
  dispensaryName,
  itemTotal=0, 
  minOrderPickup=0,
  closeMenuFn }) => {
  
  const [minOrderMet, setMinOrderMet] = React.useState();

  // Format for display
  const itemTotalFloat = parseFloat(itemTotal/100).toFixed(2);
  const minOrder = parseFloat(minOrderPickup/100).toFixed(2);

  // Check config for disabled/paused ordering
  const isOrderingPaused = config.PAUSED_DISPENSARIES.includes(dispensaryId);

  // Proceed if logged in
  const proceedToCheckout = (event) => {
    event.preventDefault();
    // close slide in cart menu
    if ( closeMenuFn ) {
      closeMenuFn(); 
    }
    navigateTop(`/placeOrder/${dispensaryId}`);
  };
 
  React.useEffect(() => {
    setMinOrderMet(itemTotal >= minOrderPickup);
  }, [itemTotal, minOrderPickup])

  return(
    <div className={styles.toCheckoutForm}>
      <form>
        { isOrderingPaused
          ? <DisabledButtonWithReason text="Checkout" isFullWidth 
                reason={`Online ordering is currently paused for ${dispensaryName}`} /> 
          : minOrderMet 
            ? <ButtonWithPrice text="Checkout" price={itemTotalFloat} handleClick={proceedToCheckout} />
            : <div className={styles.disabledMsg}>
                <ButtonWithPrice text="Checkout" disabled price={itemTotalFloat} handleClick={proceedToCheckout} />
                <sup className={styles.minOrderSup}>*</sup> 
                Minimum pickup order: ${minOrder}
              </div> 
        }
      </form>
    </div>
  )
}

CheckOutPickupButton.propTypes = {
  dispensaryId: PropTypes.string.isRequired,
  dispensaryName: PropTypes.string.isRequired,
  itemTotal: PropTypes.number.isRequired,
  minOrderPickup: PropTypes.number.isRequired,
  closeMenuFn: PropTypes.func.isRequired
};

const mapStateToProps = (state)=>{
  return {
    itemTotal: state.total
  }
}

export default connect(mapStateToProps)(CheckOutPickupButton)